import {
  BannerCarouselComponent,
  ProvinceSelectorComponent,
  BentoCardsContainerComponent,
  ProductCarouselComponent,
  VerticalFeatureCardComponent,
  MenuTileCarouselComponent,
  MediaIabComponent,
  MediaShoppableDisplayComponent,
  BrandSpotlightComponent,
  MiniInfoCardContainerComponent,
  FooterComponent,
  FireworkComponent,
  GalleryCardScrollerComponent,
  HeaderGroupComponent,
} from '../components';
// import { PaginationComponent } from '../components/pagination';

/**
 * Hook to retrieve the renderer map for SDM SDUI.
 */
export const useRendererMapSSR = () => {
  return {
    provinceListComponent: ProvinceSelectorComponent,
    bannerCarouselComponent: BannerCarouselComponent,
    bentoCardContainerComponent: BentoCardsContainerComponent,
    verticalFeatureCardContainerComponent: VerticalFeatureCardComponent,
    productCarouselComponent: ProductCarouselComponent,
    menuTileCarouselComponent: MenuTileCarouselComponent,
    fireworkComponent: FireworkComponent,
    mediaIABComponent: MediaIabComponent,
    mediaShoppableDisplayComponent: MediaShoppableDisplayComponent,
    brandSpotlightComponent: BrandSpotlightComponent,
    miniInfoCardContainerComponent: MiniInfoCardContainerComponent,
    footerContentComponent: FooterComponent,
    galleryScrollerComponent: GalleryCardScrollerComponent,
    headerGroupComponent: HeaderGroupComponent,
    // ------------------------------------------------------------
    // headerGroupComponent: HeaderGroupComponent,
    // accordionComponent: AccordionGroupComponent,
    // heroComponent: HeroBannerComponent,
    // stackedProductCarouselComponent: MiniProductTileCarouselComponent,
    // bannerWithHeadlineComponent: BannerWithHeadlineComponent,
    // productGridComponent: SimpleProductGridComponent,
    // quickFiltersComponent: QuickFiltersComponent,
    // sortsComponent: SortComponent,
    // filtersComponent: FiltersComponent,
    // categoryNavigationComponent: CategoryNavigationComponent,
    // breadcrumbsComponent: BreadcrumbComponent,
    // sortComponent: SortComponent,
    // inlineImageComponent: InlineImageComponent,
    // horizontalFeatureCardContainerComponent: HorizontalFeatureCardCollection,
    // longTextComponent: LongTextComponent,
    // navigationItemComponent: MenuDropdownComponent,
    // searchBarComponent: SearchBarComponent,
    // logoWithCtaComponent: LogoWithCtaComponent,
    // informationTextComponent: TopBarComponent,
    // infoCardContainerComponent: InfoCardContainerComponent,
    // formComponent: FormComponent,
    // acquisitionFormComponent: AcquisitionFormComponent,
    // tableComponent: TableComponent,
    // buttonGroupComponent: FilterChipComponent,
    // paginationComponent: PaginationComponent,
  };
};

export default useRendererMapSSR;

// TODO:  Add mock data, you got it from Notion doc (JSON ReSPONSE)
// TODO: Setup SDM app and test component
